import styled from 'styled-components';

import { GRADIENTS, HOME } from '../../../../theme/tokens';

/** Below this card width the chart can no longer sit beside the figures without
 *  its axis labels colliding, so it drops to its own row beneath them. This is a
 *  CONTAINER query, not a viewport @media: the card's width is set by the two-up
 *  row AND the side-menu / Lumio chrome, which a viewport breakpoint can't see. */
const STACK = '@container (max-width: 560px)';

/** The washed panel wrapping the figures + chart. Acts as the size container so
 *  the inner grid can react to the card's own width. */
export const Inner = styled.div`
  background: ${HOME.panel};
  border-radius: 16px;
  padding: 12px;
  container-type: inline-size;
`;

/** Figures on the left, trend chart + legend on the right; stacks to a single
 *  column (chart beneath the figures) once the card gets too narrow for both. */
export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(190px, 0.85fr) 1.3fr;
  gap: 24px;

  > * {
    min-width: 0;
  }

  ${STACK} {
    grid-template-columns: 1fr;
  }
`;

export const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${GRADIENTS.dividerStyledH};
`;

export const SplitRow = styled.div`
  display: flex;
  gap: 24px;
`;

export const ChartCol = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const LegendWrap = styled.div`
  margin-top: 8px;
`;
